export const TWO_MINUTES = 120000;
export const ONE_MINUTE_MS = 60000;
export const ONE_MINUTE_S = 60;

export const END_OF_SESSION_NOTIFY_S =
  (process.env.REACT_APP_END_OF_SESSION_NOTIFY_IN_MS || ONE_MINUTE_MS) / 1000;
export const END_OF_SESSION_NOTIFY_MS =
  process.env.REACT_APP_END_OF_SESSION_NOTIFY_IN_MS || ONE_MINUTE_MS;
